
import {axiosHttp} from '@/util/axios.js'

// 提交投资人信息
export function submitLeaveMessage(data){
  return axiosHttp.$getAxios("/access/addLeaveMessage", data)
}


// WEBPACK FOOTER //
// ./src/apis/cleanrSchemeAndService/index.js